exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".step3a-ede8e9ed,.step3b-3b56f798{display:flex;margin:30px auto;max-width:500px}.step3a-ede8e9ed div.col-5be23101,.step3b-3b56f798 div.col-5be23101{margin:0 20px}.step3a-ede8e9ed video,.step3b-3b56f798 video{max-height:300px;max-width:169.01408px;box-shadow:2px 2px 4px rgba(0,0,0,0.1)}.spinner-c5aece4e{display:block;margin:10px auto}.status-2eaddaea{color:#2A2A2A;background:#f5f5f5;padding:10px 20px;margin:0 0 20px 0;text-align:center}.status-2eaddaea span{vertical-align:middle}a.helpIcon-43c287d2,a.helpIcon-43c287d2:focus,a.helpIcon-43c287d2:visited{color:#BDBDBD}a.helpIcon-43c287d2:hover,a.helpIcon-43c287d2:focus:hover,a.helpIcon-43c287d2:visited:hover{color:#424242}\n", ""]);

// Exports
exports.locals = {
	"step3a": "step3a-ede8e9ed",
	"step3b": "step3b-3b56f798",
	"col": "col-5be23101",
	"spinner": "spinner-c5aece4e",
	"status": "status-2eaddaea",
	"helpIcon": "helpIcon-43c287d2"
};